<template>
  <el-dialog title="图片打码"
    :visible.sync="visible"
    @closed="handleClosed"
    :width="dialogWidth"
    append-to-body
    :close-on-press-escape="false"
    :close-on-click-modal="false">
    <div class="photo-mosaic-wrap"
      id="wrap"
      ref="wrap">
      <canvas ref="canvas"
        id="canvas"
        @mousedown.prevent="onMousedown"
        @mouseleave="onMouseleave"
        @mousemove.prevent="onMousemove"
        @mouseup.prevent="onMouseup"> </canvas>
      <div class="mouse-rect"
        v-show="flag"
        :style="rectStyle"></div>
    </div>
    <template slot="footer">
      <el-button @click="toggleModal"
        :loading="loading">取 消</el-button>
      <el-button @click="reset"
        :loading="loading">重 置</el-button>
      <el-button type="primary"
        @click="handleSubmit"
        :loading="loading">提 交</el-button>
    </template>
  </el-dialog>
</template>
<script>
const MaSize = 4
export default {
  name: 'photo-mosaic-modal',
  props: {
    callback: Function
  },
  data () {
    return {
      loading: false,
      visible: false,
      flag: false,
      rectStyle: {},
      dialogWidth: '700px',
      imageUrl: '',
      index: -1,
      image: null,
      canvas: null,
      context: null,
      pos: {
        startX: 0,
        startY: 0,
        endX: 0,
        endY: 0
      }
    }
  },
  methods: {
    toggleModal () {
      this.visible = !this.visible
    },
    handleClosed () { },
    onMouseleave (event) {
      console.log('onMouseleave')
    },
    onMousedown (event) {
      console.log('onMousedown')
      console.dir(this.$refs.canvas.getBoundingClientRect())
      console.dir(document.querySelector('#wrap').getBoundingClientRect)
      this.flag = true
      let rect = this.$refs.canvas.getBoundingClientRect()
      this.pos.startX = event.pageX - rect.left
      this.pos.startY = event.pageY - rect.top
      console.log('starX:' + this.pos.startX + ' ' + 'starY:' + this.pos.startY)
    },
    onMousemove (event) {
      console.log('onMousemove')
      let rect = this.$refs.canvas.getBoundingClientRect()
      let endX = event.pageX - rect.left
      let endY = event.pageY - rect.top
      if (this.flag) {
        let { startX, startY } = this.pos
        let maX = Math.min(startX, endX)
        let maY = Math.min(startY, endY)
        let maWidth = (Math.max(startX, endX) - Math.min(startX, endX))
        let maHeight = (Math.max(startY, endY) - Math.min(startY, endY))
        this.rectStyle = {
          left: maX + 'px',
          top: maY + 'px',
          width: maWidth + 'px',
          height: maHeight + 'px'
        }
      }
    },
    onMouseup (event) {
      console.log('onMouseup')
      if (this.flag) {
        this.flag = false
        this.rectStyle = {
          left: 0,
          top: 0,
          width: 0,
          height: 0
        }
        this.loading = true
        setTimeout(() => {
          let rect = this.$refs.canvas.getBoundingClientRect()
          this.pos.endX = event.pageX - rect.left
          this.pos.endY = event.pageY - rect.top
          console.log('endX:' + this.pos.endX + ' ' + 'endY:' + this.pos.endY)
          let { startX, startY, endX, endY } = this.pos
          let maX = Math.min(startX, endX)
          let maY = Math.min(startY, endY)
          let maWidth = (Math.max(startX, endX) - Math.min(startX, endX))
          let maHeight = (Math.max(startY, endY) - Math.min(startY, endY))
          this.dama(maX, maY, maWidth, maHeight)
          this.loading = false
        }, 20)
      }
    },
    dama (maX, maY, maWidth, maHeight) {
      let imgObj = {}
      imgObj.x = maX
      imgObj.y = maY
      imgObj.width = maWidth
      imgObj.height = maHeight
      // 开始处理这块区域
      // 先造像素点，再弄马赛克，像素点和马赛克都不只是1块
      // let pixelObj = {}  //像素取样点
      let mosaicObj = {} // 马赛克
      mosaicObj.width = MaSize
      mosaicObj.height = MaSize

      let context = this.context
      for (let i = 0; i < imgObj.width / mosaicObj.width; i++) {
        for (let j = 0; j < imgObj.height / mosaicObj.height; j++) {
          // 填完色把这块纯色马赛克put到舞台
          // pixel是在马赛克最中心点拾色
          let pixel = context.getImageData(imgObj.x + mosaicObj.width / 2 + mosaicObj.width * i, imgObj.y + mosaicObj.height / 2 + mosaicObj.height * j, 1, 1) // 只取1*1像素  科学点应该在xy分别减1，这里就不减了

          mosaicObj.img = pixel
          // 用取到的颜色把64*64的马赛克填色
          let mosaic = context.createImageData(mosaicObj.width, mosaicObj.height)
          for (let index = 0; index < mosaic.data.length; index = index + 4) {
            mosaic.data[index + 0] = pixel.data[0]
            mosaic.data[index + 1] = pixel.data[1]
            mosaic.data[index + 2] = pixel.data[2]
            mosaic.data[index + 3] = pixel.data[3]
          }
          mosaicObj.img = mosaic
          context.putImageData(mosaicObj.img, imgObj.x + mosaicObj.width * i, imgObj.y + mosaicObj.height * j) // 两个for循环打满马赛克
        }
      }
    },
    handleSubmit () {
      this.canvas.toBlob(blob => {
        this.uploadFile(blob)
      })
    },
    uploadFile (file) {
      this.loading = true
      let form = new FormData()
      form.append('file', file)
      this.$store.dispatch('common/uploadfile', {
        payload: form,
        success: (res) => {
          this.callback && this.callback({
            url: res.data.viewUrl + res.data.filepath,
            filepath: res.data.filepath
          }, this.index)
          this.loading = false
          this.toggleModal()
        },
        fail: () => {
          this.loading = false
        }
      })
    },
    reset () {
      let { width, height } = this.image
      this.context.clearRect(0, 0, width, height)
      this.context.drawImage(this.image, 0, 0, width, height)
    },
    init (imageUrl, index) {
      this.toggleModal()
      this.imageUrl = imageUrl
      this.index = index
      this.image = new Image()
      this.image.crossOrigin = ''
      this.image.src = imageUrl
      this.image.onload = () => {
        let width = this.image.width
        let height = this.image.height
        this.dialogWidth = (width + 42) + 'px'
        this.canvas = this.$refs.canvas
        this.canvas.width = width
        this.canvas.height = height
        this.context = this.canvas.getContext('2d')
        this.context.drawImage(this.image, 0, 0, width, height)
      }
    }
  }
}
</script>
<style lang="stylus" scoped>
.photo-mosaic-wrap {
  position: relative;
  border: 1px solid #333;

  .mouse-rect {
    border: 1px solid #ddd;
    z-index: 10;
    position: absolute;
  }
}
</style>
